import { defineComponent as _defineComponent } from 'vue'
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import useUser from '@/mixins/useUser';
import { PropType, computed } from 'vue';
import { ComponentInvoice, InvoiceStatus } from '@/models/Invoice';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceIncomingExtendedRowButtonArea',
  props: {
  invoice: {
    type: Object as PropType<ComponentInvoice>,
    default: null
  }
},
  emits: ['paid', 'correct_or_cancel', 'extend_due_date', 'open-chat'],
  setup(__props, { emit }) {

const props = __props;

const { tUserFallback: t } = useUser('self');




const isExtended = computed(() => !!props.invoice?.expansionDays);
const isUnpaid = computed(() => [
  InvoiceStatus.Unpaid,
  InvoiceStatus.Due,
  InvoiceStatus.Open,
  InvoiceStatus.Sent
].includes(props.invoice?.status));


return { __sfc: true,t, emit, props, isExtended, isUnpaid, BCXItemsWithPoints, BCXButton }
}

})